import ContractCard from 'src/models/contractCard.js';
import CustomerMedicalSelectionAcceptanceDetails from 'src/models/customerMedicalSelectionAcceptanceDetails.js';
import TypeOfProduct from 'src/models/typeOfProduct.js';

import { axiosInstance } from 'boot/axios';
import { isEmpty, cloneDeep } from 'lodash';

export function getContracts({ commit }, payload) {
  commit('setIsLoadingContracts', true);
  commit('setContractsForNewlyInsured', false);

  return axiosInstance
    .post('Contract/GetContractCardsForActivePolicies', payload)
    .then((response) => {
      if (!isEmpty(response.data)) {
        commit('setContracts', new ContractCard(response.data, payload));
        commit('setOriginalContracts', new ContractCard(response.data, payload));
        commit('setUnselectedRequiredPackages', []);
      }
    })
    .finally(() => commit('setIsLoadingContracts', false));
}
export function getContractsNewlyInsured({ commit }, payload) {
  commit('setIsLoadingContracts', true);
  commit('setContractsForNewlyInsured', true);

  return axiosInstance
    .post('Contract/GetContractCardsForNewlyInsuredPersons', payload)
    .then((response) => {
      if (!isEmpty(response.data)) {
        commit('setContracts', new ContractCard(response.data, payload));
        commit('setOriginalContracts', new ContractCard(response.data, payload));
        commit('setUnselectedRequiredPackages', []);
      }
    })
    .finally(() => commit('setIsLoadingContracts', false));
}

export function validateContract({ commit, getters }) {
  commit('setIsLoadingValidateContract', true);

  return axiosInstance
    .post('Contract/validate', getters.contracts.validateCard)
    .then((response) => {
      if (!isEmpty(response.data)) {
        commit('updateContractCards', response.data);
        commit(
          'setUnselectedRequiredPackages',
          response.data.unselectedRequiredPackageTypes.map((type) => new TypeOfProduct(type)),
        );
      }
    })
    .finally(() => commit('setIsLoadingValidateContract', false));
}
export function updateCardSelectionStatus({ commit }, payload) {
  commit('updateCardSelectionStatus', payload);
}
export function resolvePackageSelectionConflict({ commit }) {
  commit('resolvePackageSelectionConflict');
}
export function revertLastChange({ commit, getters }) {
  commit('setContracts', cloneDeep(getters.beforeChangeContracts));
}
export function updateBeforeChangeContracts({ commit, getters }) {
  commit('updateBeforeChangeContracts', cloneDeep(getters.contracts));
}
export function updateChosenMedicalSelectionCard({ commit }, payload) {
  commit('updateChosenMedicalSelectionCard', payload);
}

export function clearContracts({ commit }) {
  commit('clearContracts');
}

export function resetContracts({ commit, getters }) {
  commit('setContracts', cloneDeep(getters.originalContracts));
}

export function updatePaymentTerm({ commit }, payload) {
  commit('updatePaymentTerm', payload);
}

export function saveMedicalSelections({ commit, getters }, payload) {
  commit('setIsLoadingValidateContract', true);

  return axiosInstance
    .post('Contract/ValidateAndSaveMedicalSelection', {
      agreementDetails: payload.agreementDetails,
      newlyInsuredPersons: payload.newlyInsuredPersons,
      requestedContract: getters.contracts.validateCard,
    })
    .then((response) => {
      const responsData = [];
      if (!isEmpty(response.data)) {
        response.data.forEach((details) => {
          responsData.push(new CustomerMedicalSelectionAcceptanceDetails(details));
        });
        commit('setMedicalSelectionResponse', {
          customerMedicalSelectionDetails: responsData,
        });
      }
    })
    .finally(() => commit('setIsLoadingValidateContract', false));
}

export function saveNewContracts({ dispatch, getters }, payload) {
  const newPayload = {
    agreementId: payload.agreementId,
    validateCard: cloneDeep(getters.contracts.validateCard),
  };

  newPayload.validateCard.paymentInformation = {
    paymentTerm: payload.paymentTerm,
    paymentMethod: payload.paymentMethod,
    iban: payload.bankAccountNumber,
  };

  newPayload.validateCard.PersonalInformation = {
    phoneNumber: payload.phoneNumber,
    email: payload.email,
    language: payload.language,
    digitalNewsletterActive: payload.digitalNewsletterActive,
    announcementEmailActive: payload.announcementEmailActive,
  };

  return dispatch('saveContracts', newPayload);
}

export function saveContracts({ commit, getters }, payload) {
  commit('setIsSavingContracts', true);

  const validateCard = payload.validateCard ? payload.validateCard : getters.contracts.validateCard;

  return axiosInstance
    .post(`Contract/SaveContractCards?agreementNumber=${payload.agreementId}`, validateCard)
    .then((response) => {
      const isSuccesfull = response.status === 200;
      commit('setIsSavingContractsSuccesfull', isSuccesfull);

      return response;
    })
    .catch((error) => {
      if (error.response.data.packageTypes)
        commit(
          'setUnselectedRequiredPackages',
          error.response.data.packageTypes.map((type) => new TypeOfProduct(type)),
        );
      commit('setShowUnselectedRequiredPackages', true);
    })
    .finally(() => {
      commit('setIsSavingContracts', false);
    });
}

export function setIsSavingContractsSuccesfull({ commit }, payload) {
  commit('setIsSavingContractsSuccesfull', payload);
}

export function updateNewlyInsuredPersons({ commit }, payload) {
  commit('updateNewlyInsuredPersons', payload);
}

export function setShowUnselectedRequiredPackages({ commit }, payload) {
  commit('setShowUnselectedRequiredPackages', payload);
}
export function saveContractsNewlyInsuredPersons({ commit, getters }, payload) {
  commit('setIsSavingContracts', true);

  return axiosInstance
    .post(
      `Contract/SaveContractCardsForNewlyInsuredPersons?agreementNumber=${payload.agreementId}`,
      getters.contracts.validateCard,
    )
    .then((response) => {
      const isSuccesfull = response.status === 200;
      commit('setIsSavingContractsSuccesfull', isSuccesfull);
    })
    .catch((error) => {
      if (error.response.data.packageTypes)
        commit(
          'setUnselectedRequiredPackages',
          error.response.data.packageTypes.map((type) => new TypeOfProduct(type)),
        );
      commit('setShowUnselectedRequiredPackages', true);
    })
    .finally(() => {
      commit('setIsSavingContracts', false);
    });
}
export function getContractReimbursements({ commit }, payload) {
  commit('setIsLoadingContractReimbursements', true);

  return axiosInstance
    .post(`Contract/Reimbursements`, payload)
    .then((response) => {
      if (!isEmpty(response.data)) {
        commit('setContractReimbursements', response.data);
      }
    })
    .then(() => {
      commit('setIsLoadingContractReimbursements', false);
    });
}
